import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../../../store/types'
import { checkoutCurrentCheckoutDetailsSelector } from '../../checkout/store/checkoutSelectors'
import getGiftCardPurchaseCartSummaryFromCheckout from '../utils/getGiftCardPurchaseCartSummaryFromCheckout'
import { GiftCardsReducerState } from '../types'

function giftCardsStateSelector<K extends keyof GiftCardsReducerState>(
  state: RootState,
  key: K,
) {
  return state.giftCards[key]
}

export const giftCardAddonSelector = (state: RootState) =>
  giftCardsStateSelector(state, 'giftCardAddon')

export const giftCardAddonOutletSelector = (state: RootState) =>
  giftCardsStateSelector(state, 'giftCardAddonOutlet')

export const giftCardAddonIsInitializedSelector = (state: RootState) =>
  giftCardsStateSelector(state, 'giftCardAddonInitialized')

export const giftCardCheckoutPaymentParamsSelector = (state: RootState) =>
  giftCardsStateSelector(state, 'checkoutPaymentParams')

export const giftCardCheckoutCancelModalVisibleSelector = (state: RootState) =>
  giftCardsStateSelector(state, 'checkoutCancelModalVisible')

export const giftCardAddonIdSelector = createSelector(
  [giftCardAddonSelector],
  giftCardAddon => giftCardAddon?.id || null,
)

export const giftCardHasGiftCardAddonSelector = createSelector(
  [giftCardAddonSelector],
  giftCardAddon => !!giftCardAddon,
)

export const giftCardsSellOnlineIsActiveSelector = createSelector(
  [giftCardAddonSelector],
  giftCardAddon => !!giftCardAddon?.sellGiftCardsOnline,
)

export const giftCardAddonBannerImageSelector = createSelector(
  [giftCardAddonSelector],
  giftCardAddon => giftCardAddon?.bannerImage || null,
)

export const giftCardsAllowSmsSharingSelector = createSelector(
  [giftCardAddonSelector],
  giftCardAddon => !!giftCardAddon?.allowSMSSharing,
)

export const giftCardCurrentCheckoutCartSummarySelector = createSelector(
  [checkoutCurrentCheckoutDetailsSelector],
  checkout => {
    if (checkout) {
      return getGiftCardPurchaseCartSummaryFromCheckout(checkout)
    }

    return null
  },
)
